"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[466,3023],{

/***/ 80251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ logger; }
});

// EXTERNAL MODULE: ./src/providers/getEnv.ts
var getEnv = __webpack_require__(4266);
// EXTERNAL MODULE: ./node_modules/@sentry/types/esm/severity.js
var severity = __webpack_require__(13819);
;// CONCATENATED MODULE: ./src/helpers/logger/JustoError.ts
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent1, args1, Class1) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _wrapNativeSuper(Class2) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class2);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var JustoError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(JustoError, Error1);
    var _super = _createSuper(JustoError);
    function JustoError(errMessage, data) {
        var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "error";
        _classCallCheck(this, JustoError);
        var _this;
        _this = _super.call(this, errMessage);
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_assertThisInitialized(_this), JustoError);
        }
        _this.name = "JustoError";
        return _this;
    }
    return JustoError;
}(_wrapNativeSuper(Error));


;// CONCATENATED MODULE: ./src/helpers/logger/transports.ts


var logException = function(exception) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39666)).then(function(param) {
        var captureException = param.captureException;
        captureException(exception, {
            tags: {
                errorLevel: "JustoException"
            },
            level: severity/* Severity.Error */.z.Error,
            extra: data
        });
        console.error("Justo<exception>", exception, data);
    });
};
var logError = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39666)).then(function(param) {
        var captureException = param.captureException;
        captureException(new JustoError(message, data), {
            tags: {
                errorLevel: "JustoError"
            },
            level: severity/* Severity.Error */.z.Error,
            extra: data
        });
        console.error("Justo<error>", message, data);
    });
};
var logWarn = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39666)).then(function(param) {
        var captureMessage = param.captureMessage;
        captureMessage(new JustoError(message, data, "warning").message, {
            tags: {
                errorLevel: "JustoWarning"
            },
            level: severity/* Severity.Warning */.z.Warning,
            extra: data
        });
        console.warn("Justo<warn>", message, data);
    });
};
var logDebug = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    console.log("Justo<debug>", message, data);
    console.trace();
};
var logInfo = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    console.info("Justo<info>", message, data);
};
var log = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    console.info("Justo<log>", message, data);
    console.trace();
};
var envConfig = {
    local: {
        exception: logInfo,
        error: log,
        warn: log,
        info: logInfo,
        debug: logDebug
    },
    prod: {
        exception: logException,
        error: logError,
        warn: logWarn,
        info: logInfo,
        debug: logDebug
    },
    dev: {
        exception: logException,
        error: logError,
        warn: logWarn,
        info: logInfo,
        debug: logDebug
    }
};
/* harmony default export */ var transports = (envConfig);

;// CONCATENATED MODULE: ./src/helpers/logger/index.ts


/* harmony default export */ var logger = (transports[(0,getEnv/* default */.Z)()]);


/***/ }),

/***/ 53023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EVENTS": function() { return /* binding */ EVENTS; },
/* harmony export */   "sendPosthogData": function() { return /* binding */ sendPosthogData; },
/* harmony export */   "sendPosthogUserInfo": function() { return /* binding */ sendPosthogUserInfo; },
/* harmony export */   "setBasicProperties": function() { return /* binding */ setBasicProperties; },
/* harmony export */   "setPosthogUserId": function() { return /* binding */ setPosthogUserId; }
/* harmony export */ });
/* harmony import */ var _helpers_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80251);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
/* harmony import */ var posthog_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99893);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var setPosthogUserId = function(userId) {
    try {
        posthog_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].identify */ .Z.identify(userId);
    } catch (e) {
        _helpers_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(e);
        _helpers_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].exception */ .Z.exception("Posthog not loaded");
    }
};
var setBasicProperties = function(properties) {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()) return;
    properties = _objectSpread({}, properties, {
        store: window.location.hostname,
        storeUrl: window.location.hostname,
        path: window.location.pathname,
        websiteVersion: "nextjs"
    });
    posthog_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].register */ .Z.register(properties);
};
var sendPosthogUserInfo = function(userInfo) {
    try {
        posthog_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].people.set */ .Z.people.set(userInfo);
    } catch (e) {
        _helpers_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(e);
        _helpers_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].exception */ .Z.exception("Posthog not loaded");
    }
};
var sendPosthogData = function(eventType) {
    var eventProperties = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    try {
        var obj = JSON.parse(JSON.stringify(eventProperties));
        posthog_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].capture */ .Z.capture(eventType, _objectSpread({}, obj));
    } catch (e) {
        console.error({
            e: e
        });
        _helpers_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].exception */ .Z.exception("Posthog not loaded");
    }
};
var EVENTS = Object.freeze({
    clicked: {
        productChangeAmount: "clicked-productChangeAmount",
        addressComponentOrder: "clicked-addressComponentOrder",
        checkoutLogin: "clicked-checkoutLogin",
        upselling: "clicked-upselling",
        login: "clicked-login",
        cartRemoveProduct: "clicked-cartRemoveProduct",
        cartContinueToCheckout: "clicked-cartContinueToCheckout",
        cart: "clicked-cart",
        search: "clicked-search",
        product: "clicked-product",
        productAddToCart: "clicked-productAddToCart",
        help: "clicked-help",
        cancelOrder: "clicked-cancel-order",
        changePreferredStore: "clicked-change-preferred-store",
        omitLogin: "clicked-omit-login",
        editProduct: "clicked-edit-product",
        saveEditProduct: "clicked-save-edit-product",
        giftCheckout: "clicked-gift-checkout",
        useLocation: "clicked-use-location",
        addressSubmitButton: "clicked-address-submit-button"
    },
    selected: {
        addressOption: "selected-address-option"
    },
    error: {
        locationAccessDenied: "error-location-access-denied",
        locationUnavailable: "error-location-unavailable"
    },
    product: {
        setQuantityTo0: "update-quantity-0-product"
    },
    pageView: {
        checkout: "pageView-checkout",
        order: "pageView-order",
        home: "pageView-home",
        tracking: "pageView-tracking",
        publication: "pageView-publication"
    },
    coupon: {
        apply: "coupon-apply",
        failed: "coupon-failed"
    },
    address: {
        failed: "address-failed",
        accept: "address-accept"
    },
    pay: {
        passValidations: "pay-passValidations",
        failed: "pay-failed",
        successful: "pay-successful",
        successfulTest: "pay-successful-test"
    },
    login: "login",
    startSession: "start-session"
});


/***/ }),

/***/ 69598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WithPosthog": function() { return /* binding */ WithPosthog; },
  "default": function() { return /* binding */ usePosthog; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/helpers/posthog/index.ts
var posthog = __webpack_require__(53023);
;// CONCATENATED MODULE: ./src/helpers/posthog/config.ts
var posthogProd = "phc_6iSnqhLXoUrIssc5cfgjf9YrF5voKG18RK9Sk9bKuSM";
var posthogDev = "phc_JO6OBNTSVv4G3rLGXMysmHxsEAOTaHXjFExlP5hMsgs";
var urlPosthogProd = "https://posthog.tools.justo.ninja";
var urlPosthogDev = "https://posthog.sandbox.justo.ninja";

// EXTERNAL MODULE: ./src/providers/getEnv.ts
var getEnv = __webpack_require__(4266);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/posthog-js/dist/es.js
var es = __webpack_require__(99893);
;// CONCATENATED MODULE: ./src/helpers/posthog/usePosthog.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






function usePosthog(param) {
    var pageProps = param.pageProps;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        // Init PostHog
        es/* default.init */.Z.init((0,getEnv/* default */.Z)() === "prod" ? posthogProd : posthogDev, {
            api_host: (0,getEnv/* default */.Z)() === "prod" ? urlPosthogProd : urlPosthogDev
        });
        // if need to test new events please remove this if
        if ((0,getEnv/* default */.Z)() === "local") {
            es/* default.opt_out_capturing */.Z.opt_out_capturing();
        } else {
            es/* default.clear_opt_in_out_capturing */.Z.clear_opt_in_out_capturing();
        }
        (0,posthog.setBasicProperties)(_objectSpread({}, pageProps.website));
        // Track page views
        var handleRouteChange = function() {
            return es/* default.capture */.Z.capture("$pageview");
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, []);
    return null;
};
var WithPosthog = function(param) {
    var pageProps = param.pageProps, children = param.children;
    usePosthog({
        pageProps: pageProps
    });
    return children;
};


/***/ })

}]);